// extracted by mini-css-extract-plugin
export default {"tile":"Calendar_tile__gaft8"};